<div
  [class.desktop-main]="isDesktop()"
  [class.mobile]="isMobile()"
  [class.tablet]="isTablet()"
>
  @if (plant() && (!emptyResults() || !isDesktop())) {
    <div class="plant-thumbnail-header">
      @if (isDesktop()) {
        <nz-avatar
          [nzSrc]="
            plant()['thumbnail']
              ? plant()['thumbnail']
              : 'assets/images/plant_default_picture.png'
          "
          [nzSize]="80"
          nzText="Plant"
        ></nz-avatar>
      }
      <div>
        <app-breadcrumbs
          [object]="plant()"
          class="breadcrumbsSmallMargin"
        ></app-breadcrumbs>
        <h1>
          {{ plant().objectName }} [{{
            plant().Assets.length -
              plant().Archived.length -
              plant().AssetsWithoutSensors.length
          }}]
        </h1>
      </div>
    </div>
    @if (!isDesktop()) {
      <!---removed Input,FilterChanged and filter here as there is no property created in search filter and plnt ovrvw--->
      <!-- <app-search-filter (FilterChanged)="onFilterChanged($event)" [Input]="plant().children" [filter]="filter"
        [plantFilterStatus]="mobfilterStatus" [plantID]="plantID">
      </app-search-filter> -->
      <app-search-filter
        [plantFilterStatus]="mobfilterStatus()"
        [sidebar]="false"
      >
      </app-search-filter>
    }
    <ng-container>
      @if (!emptyResults()) {
        @if (!plant().filtered) {
          <div>
            <div class="found-wrapper">
              <h3>
                {{
                  assetCount() > 1
                    ? assetCount() + " " + i18n.langString("equipments_found")
                    : assetCount() === 1
                      ? "1 " + i18n.langString("equipment_found")
                      : i18n.langString("no_equipments_found")
                }}
              </h3>
              @if (assetCount() === 0) {
                <h5 class="marginTop24">
                  {{ i18n.langString("no_equipments_found2") }}
                </h5>
              }
            </div>
          </div>
        }
        @if (
          plant().Critical.length === 0 &&
          plant().Warning.length === 0 &&
          plant().InActive.length === 0 &&
          plant().Working.length > 0
        ) {
          <div class="nz-multiple-status-reports nz-multiple-reports-left">
            <nz-alert
              nzType="success"
              class="nz-status-report"
              [nzMessage]="allfineTemplate"
            ></nz-alert>
            <ng-template #allfineTemplate>
              <i nz-icon nzType="icons:status-check" class="fillgreen"></i>
              <span class="body-bold">{{
                i18n.langString("all_equipments_working_fine")
              }}</span></ng-template
            >
          </div>
        }

        @if (
          plant().Critical.length > 0 ||
          plant().Warning.length > 0 ||
          plant().InActive.length > 0
        ) {
          <div class="nz-multiple-status-reports nz-multiple-reports-left">
            @if (plant().InActive.length > 0) {
              <nz-alert
                nzType="info"
                class="nz-status-report"
                [nzMessage]="inActiveTemplate"
              ></nz-alert>
              <ng-template #inActiveTemplate>
                <i
                  nz-icon
                  nzType="icons:cross-circle"
                  class="fillblackcoral"
                ></i>
                <span class="body-bold">
                  {{ plant().InActive.length }}
                  {{
                    plant().InActive.length === 1
                      ? i18n.langString("in_active_sensor")
                      : i18n.langString("in_active_sensors")
                  }}
                </span>
              </ng-template>
            }
            @if (plant().Critical.length > 0) {
              <nz-alert
                nzType="error"
                class="nz-status-report"
                [nzMessage]="errorTemplate"
              ></nz-alert>
              <ng-template #errorTemplate>
                <i
                  nz-icon
                  nzType="icons:status-exclamation-triangle"
                  class="fillred"
                ></i>
                <span class="body-bold">
                  {{ plant().Critical.length }}
                  {{
                    plant().Critical.length === 1
                      ? i18n.langString("critical_equipment")
                      : i18n.langString("critical_equipments")
                  }}
                </span>
              </ng-template>
            }

            @if (plant().Warning.length > 0) {
              <nz-alert
                nzType="warning"
                class="nz-status-report"
                [nzMessage]="warningTemplate"
              ></nz-alert>
              <ng-template #warningTemplate>
                <i
                  nz-icon
                  nzType="icons:status-exclamation-octagon"
                  class="fillorange"
                ></i>
                <span class="body-bold">
                  {{ plant().Warning.length }}
                  {{
                    plant().Warning.length === 1
                      ? i18n.langString("warning_equipment")
                      : i18n.langString("warning_equipments")
                  }}
                </span>
              </ng-template>
            }
            @if (plant().Working.length > 0) {
              <nz-alert
                nzType="success"
                class="nz-status-report"
                [nzMessage]="otherfineTemplate"
              ></nz-alert>
              <ng-template #otherfineTemplate>
                <i nz-icon nzType="icons:status-check" class="fillgreen"></i>
                <span class="body-bold">
                  {{ plant().Working.length }}
                  {{
                    plant().Working.length === 1
                      ? i18n.langString("other_equipment_working_fine")
                      : i18n.langString("other_equipments_working_fine")
                  }}
                </span>
              </ng-template>
            }
            @if (plant().Archived.length > 0) {
              <nz-alert
                class="nz-status-report"
                [nzMessage]="archivedTemplate"
              ></nz-alert>
              <ng-template #archivedTemplate
                ><i nz-icon nzType="icons:folder"></i>
                @if (plant().Archived.length === 1) {
                  <span class="body-bold">
                    {{ plant().Archived.length }}
                    {{ i18n.langString("deinstalled_equipment") }}</span
                  >
                }
                @if (plant().Archived.length > 1) {
                  <span class="body-bold">
                    {{ plant().Archived.length }}
                    {{ i18n.langString("deinstalled_equipments") }}</span
                  >
                }
              </ng-template>
            }
          </div>
        }
        @if (
          (plant().Assets.length -
            plant().Archived.length -
            plant().AssetsWithoutSensors.length <=
            25 ||
            !plant().NextLayerIsAboveEquipment) &&
          !plant().filtered
        ) {
          @for (building of buildings(); track building.objectID) {
            <app-card [plant]="building" [detail]="true" [showLayer]="true">
              <div class="card-layer">
                @for (
                  equipment of building.AssociatedEquipments;
                  track equipment.objectID
                ) {
                  @if (equipment.objectID !== building.objectID) {
                    <div class="card-layer-subtitle">
                      <span class="card-layer-subtitle-layername detail">
                        {{ i18n.parse(equipment.layerName) }}
                      </span>
                      @if (equipment.Assets.length > 0) {
                        <span class="body-bold card-layer-subtitle">
                          {{ i18n.parse(equipment.objectName) }}
                        </span>
                      }
                    </div>
                  }

                  <div class="card-layer-content">
                    @for (asset of equipment.Assets; track asset.objectID) {
                      @if (
                        asset.critical && !asset.inactive && !asset.isArchived
                      ) {
                        <app-asset-nav-button
                          [asset]="asset"
                          svg_icon="icons:status-exclamation-triangle"
                        >
                          {{ asset.objectName | nameSlice }}
                        </app-asset-nav-button>
                      }

                      @if (
                        asset.warning &&
                        !asset.inactive &&
                        !asset.critical &&
                        !asset.isArchived
                      ) {
                        <app-asset-nav-button
                          [asset]="asset"
                          svg_icon="icons:status-exclamation-octagon"
                        >
                          {{ asset.objectName | nameSlice }}
                        </app-asset-nav-button>
                      }

                      @if (asset.inactive && !asset.isArchived) {
                        <app-asset-nav-button
                          [asset]="asset"
                          svg_icon="icons:cross-circle"
                        >
                          {{ asset.objectName | nameSlice }}
                        </app-asset-nav-button>
                      }

                      @if (
                        !asset.critical &&
                        !asset.warning &&
                        !asset.inactive &&
                        !asset.isArchived
                      ) {
                        <app-asset-nav-button
                          [asset]="asset"
                          [working]="true"
                          svg_icon="icons:status-check"
                        >
                          {{ asset.objectName | nameSlice }}
                        </app-asset-nav-button>
                      }
                    }

                    <div class="show_inactive">
                      @if (building.Archived.length > 0) {
                        <app-nav-button
                          (clickEvent)="onDisabledAsset(building)"
                          [primary]="true"
                          svgIcon="icons:deinstall"
                        >
                          {{ i18n.langString("show_inactive_equipments") }}
                        </app-nav-button>
                      }
                    </div>
                  </div>
                }
              </div>
            </app-card>
          }
        }
        @if (
          plant().Assets.length -
            plant().Archived.length -
            plant().AssetsWithoutSensors.length >
            25 &&
          plant().NextLayerIsAboveEquipment &&
          !plant().filtered
        ) {
          <div class="cards ga-zone-wrapper">
            @for (
              building of sortCritFirst(buildings());
              track building.objectID
            ) {
              <button
                class="ga-zone-card"
                [class.ga-zone-critical]="building.Critical.length > 0"
                (click)="toLowerItem(building)"
              >
                @if (building.Critical.length > 0) {
                  <i
                    nz-icon
                    nzType="icons:status-exclamation-triangle"
                    class="svg-icon mini-svg-icon fillwhite"
                  ></i>
                }

                <h2>
                  {{ building.objectName }} [
                  {{
                    building.Assets.length -
                      building.Archived.length -
                      building.AssetsWithoutSensors.length
                  }}
                  ]
                </h2>
              </button>
            }
          </div>
        }
      }
    </ng-container>

    <ng-container>
      @if (plant().filtered) {
        <app-card [plant]="plant()" [fine]="false">
          @for (
            bcCluster of assetsGroupBy(plant());
            track bcCluster[0]?.objectID
          ) {
            <app-breadcrumbs
              [object]="bcCluster[0]"
              [shorten]="3"
            ></app-breadcrumbs>
            <div class="search-result-wrapper">
              @for (asset of bcCluster; track asset.objectID) {
                <app-asset-nav-button
                  [asset]="asset"
                  [svg_icon]="statusChecked(asset)"
                >
                  {{ asset.objectName | nameSlice }}
                </app-asset-nav-button>
              }
            </div>
          }
        </app-card>
      }
    </ng-container>
  }
  @if (!loading() && emptyResults()) {
    @if (!isDesktop()) {
      <!---removed Input,FilterChanged and filter here as there is no property created in search filter and plnt ovrvw--->
      <!-- <app-search-filter (FilterChanged)="onFilterChanged($event)" [filter]="filter"
        [plantsFilter]="true" [plantFilterStatus]="mobfilterStatus">
      </app-search-filter> -->
      <app-search-filter
        [plantsFilter]="true"
        [plantFilterStatus]="mobfilterStatus"
      >
      </app-search-filter>
    }
    <h3>{{ i18n.langString("no_equipments_found") }}</h3>
    <h5 class="marginTop24">{{ i18n.langString("no_equipments_found2") }}</h5>
  }
</div>
